import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import React, { useState } from 'react';
import { useSelect } from '../api';
export const SelectUser = ({
  value,
  onChange,
  mode = undefined
}) => {
  const [mobile, setMobile] = useState('');
  const {
    data,
    isFetching
  } = useSelect({
    params: {
      mobile,
      pageIndex: 1,
      pageSize: 10
    },
    config: {
      enabled: mobile.length > 0
    }
  });
  return /*#__PURE__*/React.createElement(_Select, {
    showSearch: true,
    allowClear: true,
    mode: mode,
    options: data?.data.items.map(v => ({
      label: `ID:${v.id}-姓名:${v.real_name}-手机号${v.mobile}`,
      value: v.id
    })),
    loading: isFetching,
    placeholder: "\u901A\u8FC7\u624B\u673A\u53F7\u641C\u7D22\u7528\u6237",
    filterOption: false,
    onChange: onChange,
    value: value,
    notFoundContent: isFetching ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React.createElement(_Spin, {
      style: {
        margin: 12
      }
    })) : null,
    onSearch: value => {
      setMobile(value);
    }
  });
};